












import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import VIcon from './VIcon.vue';
import Number from '../filters/Number';

@Component({ components: { VIcon }, filters: { Number } })
export default class VNumberPicker extends Vue {
  @Prop() readonly value!: number;
  @Prop({ default: 1 }) readonly step!: number;
  @Prop({ default: 0 }) readonly min!: number;
  @Prop({ default: null }) readonly max!: number|null;
  @Prop({ default: false }) readonly loop!: boolean;
  @Prop({ default: 1 }) readonly digits? : number|null;

  number = 0;

  @Watch('value')
  onValueChange(value: number) {
    this.number = value;
  }

  created() {
    this.number = this.value;
  }

  up() {
    if (this.step) {
      const number = this.number + this.step;

      if ((this.max != null && this.max >= number) || this.max === null) {
        this.number = number;
      } else if (this.min != null && this.loop) {
        this.number = this.min;
      }

      this.$emit('input', this.number);
    }
  }

  down() {
    if (this.step) {
      const number = this.number - this.step;

      if ((this.min != null && this.min <= number) || this.min === null) {
        this.number = number;
        this.$emit('input', this.number);
      } else if (this.max != null && this.loop) {
        this.number = this.max;
      }
    }
  }
}
